import React, { useState, useRef, useEffect } from "react";
import { X, UserPlus, ShieldCheck,ChevronDown } from "lucide-react";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(window.innerWidth > 1024);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [formData, setFormData] = useState({
    username: "",
    firstName: "",
    lastName: "",
    email: "",
    roleId: "",
    password: "123",
    allowedPage: "",
  });

  // الصفحات المتاحة لتقييد مستخدم بصفحة واحدة فقط (حالة خاصة)
  const availablePages = [
    { path: "", label: "بدون تقييد (حسب الدور الوظيفي)" },
    { path: "/dashboard", label: "لوحة التحكم" },
    { path: "/departments", label: "الإدارات" },
    { path: "/archivadmin", label: "أرشيف الإدارة" },
    { path: "/planadmin", label: "الخطة" },
    { path: "/reports", label: "التقارير" },
    { path: "/employees", label: "الموظفين" },
    { path: "/users", label: "المستخدمين" },
    { path: "/settings", label: "الإعدادات" },
    { path: "/SupportdSec1", label: "إدارة دعم التعاملات الضريبية" },
  ];

  const navigate = useNavigate();


  const fetchWithAuth = async (url) => {
    const token = localStorage.getItem("token");
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (response.status === 401) throw new Error("Unauthorized");
    return response.json();
  };

  const fetchData = async () => {
    try {
      const [usersData, rolesData] = await Promise.all([
        fetchWithAuth("/api/users"),
        fetchWithAuth("/api/roles"),
      ]);
      setUsers(Array.isArray(usersData) ? usersData : []);
      setRoles(Array.isArray(rolesData) ? rolesData : []);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: id === "roleId" ? (value === "" ? "" : parseInt(value)) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("/api/users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          ...formData,
          roleId: parseInt(formData.roleId),
        }),
      });
      if (response.ok) {
        setIsModalOpen(false);
        fetchData(); // تحديث الجدول بعد الإضافة
        setFormData({
          username: "",
          firstName: "",
          lastName: "",
          email: "",
          roleId: "",
          password: "123",
          allowedPage: "",
        });
      } else {
        const data = await response.json();
        alert(data.message || "فشل في إضافة المستخدم");
      }
    } catch (error) {
      console.error("Error adding user:", error);
    }
  };

  // تغيير حالة المستخدم (حظر / فك حظر)
  // الباك إند بيحسب الحالة الجديدة بنفسه ويرجعها في الـ response
  const toggleUserStatus = async (userId) => {
    try {
      const response = await fetch(
        `/api/users/${userId}/toggle-status`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        // تحديث الحالة محليًا بالقيمة الراجعة فعليًا من السيرفر
        setUsers((prev) =>
          prev.map((u) =>
            u.id === userId ? { ...u, status: data.status } : u
          )
        );
      } else {
        alert(data.message || "فشل في تغيير حالة المستخدم");
      }
    } catch (error) {
      console.error("Error toggling user status:", error);
      alert("حدث خطأ أثناء تغيير حالة المستخدم");
    }
  };

  // تقييد/إلغاء تقييد مستخدم موجود بصفحة واحدة فقط
  const handleAllowedPageChange = async (userId, allowedPage) => {
    try {
      const response = await fetch(
        `/api/users/${userId}/allowed-page`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ allowedPage: allowedPage || null }),
        }
      );
      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        setUsers((prev) =>
          prev.map((u) =>
            u.id === userId ? { ...u, allowedPage: data.allowedPage } : u
          )
        );
      } else {
        alert(data.message || "فشل في تحديث صلاحية الصفحة");
      }
    } catch (error) {
      console.error("Error updating allowed page:", error);
      alert("حدث خطأ أثناء تحديث صلاحية الصفحة");
    }
  };

  return (
    <div
      className="flex min-h-screen bg-[#F8F9FA] font-ibm overflow-hidden"
      dir="rtl"
    >
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
      />

      <div
        className={`flex-1 transition-all duration-300 p-4 md:p-8 overflow-y-auto ${isSidebarOpen ? "lg:mr-64" : "lg:mr-20"}`}
      >
        <Header
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
          title="المستخدمين"
        />
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-10 gap-6">
          <div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#546E7A]">
              إعدادات المستخدمين
            </h2>
            <p className="text-gray-400 mt-1">إدارة صلاحيات المستخدمين</p>
          </div>
          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-[#546E7A] hover:bg-[#263238] text-white font-ibm px-8 py-3 rounded-2xl font-bold flex items-center gap-2 transition shadow-lg shadow-[#546e7a20] w-full md:w-auto justify-center active:scale-95"
          >
            <UserPlus size={20} /> مستخدم جديد
          </button>
        </div>

        <div className="bg-white rounded-[2rem] shadow-sm border border-gray-50 overflow-hidden">
          {/* Table - desktop only */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-right">
              <thead>
                <tr className="bg-[#F8F9FA] text-[#546E7A] border-b border-gray-50">
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    اسم المستخدم
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    الاسم الأول
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    الاسم الأخير
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    البريد الإلكتروني
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    الحالة
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    الدور الوظيفي
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-right whitespace-nowrap">
                    تقييد بصفحة واحدة
                  </th>
                  <th className="px-6 py-5 font-bold text-sm text-center whitespace-nowrap">
                    إجراءات
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {users.map((user) => (
                  <tr
                    key={user.id}
                    className="hover:bg-gray-50/50 transition-colors"
                  >
                    <td className="px-6 py-4 text-sm font-bold text-[#263238] whitespace-nowrap">
                      {user.username}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600 whitespace-nowrap">
                      {user.firstName}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600 whitespace-nowrap">
                      {user.lastName}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                      {user.email}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-bold ${user.status === "محظور" ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}
                      >
                        {user.status || "مفعل"}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-[#546E7A] whitespace-nowrap">
                      {user.role?.name || "بدون دور"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <select
                        value={user.allowedPage || ""}
                        onChange={(e) =>
                          handleAllowedPageChange(user.id, e.target.value)
                        }
                        className="text-xs font-medium border border-gray-100 bg-gray-50 rounded-xl px-3 py-2 outline-none focus:border-[#546E7A] text-right"
                      >
                        {availablePages.map((p) => (
                          <option key={p.path} value={p.path}>
                            {p.label}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td className="px-6 py-4 text-center whitespace-nowrap">
                      {user.email !== "sheko_ez@hotmail.com" && (
                        <button
                          onClick={() => toggleUserStatus(user.id)}
                          className={`${user.status === "محظور" ? "bg-gray-500" : "bg-[#FF8A80] hover:bg-red-500"} text-white px-5 py-2 rounded-xl text-xs font-bold transition-all active:scale-95`}
                        >
                          {user.status === "محظور" ? "فك الحظر" : "حظر"}
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Cards - mobile only */}
          <div className="md:hidden divide-y divide-gray-50">
            {users.map((user) => (
              <div
                key={user.id}
                className="p-4 hover:bg-gray-50/50 transition-colors"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="font-bold text-[#263238] text-sm">
                    {user.username}
                  </span>
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-bold ${user.status === "محظور" ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}
                  >
                    {user.status || "مفعل"}
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-2 mb-3 text-xs">
                  <div>
                    <span className="text-gray-400">الاسم الأول</span>
                    <p className="text-gray-600 font-medium">
                      {user.firstName}
                    </p>
                  </div>
                  <div>
                    <span className="text-gray-400">الاسم الأخير</span>
                    <p className="text-gray-600 font-medium">{user.lastName}</p>
                  </div>
                  <div>
                    <span className="text-gray-400">البريد الإلكتروني</span>
                    <p className="text-gray-500 truncate">{user.email}</p>
                  </div>
                  <div>
                    <span className="text-gray-400">الدور الوظيفي</span>
                    <p className="text-[#546E7A] font-medium">
                      {user.role?.name || "بدون دور"}
                    </p>
                  </div>
                </div>
                <div className="mb-3">
                  <span className="text-gray-400 text-xs">تقييد بصفحة واحدة</span>
                  <select
                    value={user.allowedPage || ""}
                    onChange={(e) =>
                      handleAllowedPageChange(user.id, e.target.value)
                    }
                    className="w-full mt-1 text-xs font-medium border border-gray-100 bg-gray-50 rounded-xl px-3 py-2 outline-none focus:border-[#546E7A] text-right"
                  >
                    {availablePages.map((p) => (
                      <option key={p.path} value={p.path}>
                        {p.label}
                      </option>
                    ))}
                  </select>
                </div>
                {user.email !== "sheko_ez@hotmail.com" && (
                  <button
                    onClick={() => toggleUserStatus(user.id)}
                    className={`w-full ${user.status === "محظور" ? "bg-gray-500" : "bg-[#FF8A80] hover:bg-red-500"} text-white py-2 rounded-xl text-xs font-bold transition-all active:scale-95`}
                  >
                    {user.status === "محظور" ? "فك الحظر" : "حظر"}
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>

        {isModalOpen && (
          <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
            <div className="flex min-h-full items-center justify-center p-4">
              <div
                className="fixed inset-0 bg-[#263238]/60 backdrop-blur-sm"
                onClick={() => setIsModalOpen(false)}
              ></div>
              <div
                className="relative bg-white w-full max-w-2xl rounded-[2.5rem] shadow-2xl overflow-hidden text-right"
                dir="rtl"
              >
                <div className="p-8 flex justify-between items-center">
                  <div className="flex items-center gap-3">
                    
                    <h3 className="text-xl font-bold text-[#263238]">
                      إضافة مستخدم جديد
                    </h3>
                  </div>
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="p-2 hover:bg-gray-200 rounded-full transition-colors"
                  >
                    <X size={24} className="text-gray-400" />
                  </button>
                </div>
                <form onSubmit={handleSubmit} className="p-8 space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="relative">
                      <input
                        type="text"
                        id="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        placeholder=" "
                        className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right"
                      />
                      <label
                        htmlFor="username"
                        className="absolute text-sm font-bold text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                      >
                        اسم المستخدم
                      </label>
                    </div>
                    <div className="relative">
                      <input
                        type="text"
                        id="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                        placeholder=" "
                        className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right"
                      />
                      <label
                        htmlFor="firstName"
                        className="absolute text-sm font-bold text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                      >
                        الاسم الأول
                      </label>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="relative">
                      <input
                        type="text"
                        id="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                        placeholder=" "
                        className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right"
                      />
                      <label
                        htmlFor="lastName"
                        className="absolute text-sm font-bold text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                      >
                        الاسم الأخير
                      </label>
                    </div>
                    <div className="relative">
                      <input
                        type="email"
                        id="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder=" "
                        className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right"
                      />
                      <label
                        htmlFor="email"
                        className="absolute text-sm font-bold text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                      >
                        البريد الإلكتروني
                      </label>
                    </div>
                  </div>
                  <div className="relative">
                    <select
                      id="roleId"
                      value={formData.roleId}
                      onChange={handleChange}
                      required
                      className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right appearance-none"
                    >
                      <option value="" disabled hidden></option>
                      {roles.length > 0 ? (
                        roles.map((role) => (
                          <option key={role.id} value={role.id}>
                            {role.name}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled hidden></option>
                      )}
                    </select>
                    <label
                      htmlFor="roleId"
                      className="absolute text-sm font-bold text-gray-400 duration-300 transform -translate-y-0 scale-75 top-4 z-10 origin-[100%] right-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                    >
                      الدور الوظيفي
                    </label>
                    <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                      <ChevronDown size={18} />
                    </div>
                  </div>
                  <div className="relative">
                    <select
                      id="allowedPage"
                      value={formData.allowedPage}
                      onChange={handleChange}
                      className="peer w-full px-5 py-4 rounded-2xl border border-gray-100 bg-gray-50 focus:bg-white focus:border-[#546E7A] outline-none transition-all pt-7 text-right appearance-none"
                    >
                      {availablePages.map((p) => (
                        <option key={p.path} value={p.path}>
                          {p.label}
                        </option>
                      ))}
                    </select>
                    <label
                      htmlFor="allowedPage"
                      className="absolute text-sm font-bold text-gray-400 duration-300 transform -translate-y-0 scale-75 top-4 z-10 origin-[100%] right-5 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A]"
                    >
                      تقييد بصفحة واحدة (اختياري - لحالات خاصة)
                    </label>
                    <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                      <ChevronDown size={18} />
                    </div>
                  </div>
                  <div className="flex gap-4 pt-4">
                    <button
                      type="submit"
                      className="flex-[2] bg-[#546E7A] hover:bg-[#263238] text-white py-4 rounded-2xl font-bold transition-all shadow-xl shadow-[#546e7a30] active:scale-[0.98]"
                    >
                      إضافة مستخدم
                    </button>
                    <button
                      type="button"
                      onClick={() => setIsModalOpen(false)}
                      className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-600 py-4 rounded-2xl font-bold transition-all active:scale-[0.98]"
                    >
                      إلغاء
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Users;